import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import * as S3 from 'aws-sdk/clients/s3';
import awsExports from '../../aws-exports';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  constructor(public http: HttpClient) {}

  private header = new HttpHeaders({
    'Content-Type': 'application/json',
    'x-api-key': environment.apiKey,
  });
  public downloadFile(key: string): Observable<any> {
    const body = {
      query: `
        query {
          downloadFile(key: "${key}") {
            code
          }
        }    
      `,
    };
    return this.http.post(environment.baseUrl, body, { headers: this.header });
  }
}
